import { FileSignature } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const docs = defineDashboardModule({
  id: "docs",
  nav: [{ group: "Business", title: "Docs", to: "/docs", icon: FileSignature }],
  routes: [
    {
      path: "/docs",
      component: lazyPage(() => import("./routes/docs-page"), "DocsPage"),
    },
  ],
})
